module.exports = __webpack_public_path__ + "resources/img/main_banner_gov03_m.87f54be6c7391f59bcb2ab7a685f09db.png";